import { useTranslation } from 'react-i18next';
import Devices from 'types/Devices';
import TypeButton from 'components/Buttons/TypeButton';
import { ReactComponent as IconDesktop } from 'assets/images/icons/icon-desktop.svg';

type DesktopButtonProps = {
  onClick: (device: Devices) => void
  activeDevice: Devices,
};

const DesktopButton = ({ onClick, activeDevice }: DesktopButtonProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <TypeButton
      content={ t('button_example_desktop') }
      icon={ <IconDesktop /> }
      onClick={ () => onClick(Devices.Desktop) }
      active={ activeDevice === Devices.Desktop }
    />
  );
};

export default DesktopButton;
